module.exports = __webpack_public_path__ + "img/wallet_02_evm_2.e6ad9650.png";